import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  QRButtonOrder,
  QROrderDirection,
} from '@base/src/app/models/qr-button-order.model';
import { Constants } from '@base/src/app/models/constants';
import { QRIcon } from '@base/src/app/models/qr-icon.model';

@Component({
  selector: 'qr-button-order',
  templateUrl: './button-order.component.html',
  styleUrls: ['./button-order.component.scss'],
})
export class ButtonOrderComponent {
  @Input() config: QRButtonOrder = new QRButtonOrder();
  @Input() selected: QROrderDirection | null = null;
  @Input() isDisabled = false;
  @Output() orderChange = new EventEmitter<QROrderDirection>();

  readonly iconAsc = Constants.ICONS.ARROW_NORTH;
  readonly iconDesc = Constants.ICONS.ARROW_SOUTH;

  get iconAscColor(): string {
    return this.selected === 'asc' && !this.isDisabled
      ? QRIcon.COLOR_PRIMARY_700
      : QRIcon.COLOR_GREY_400;
  }

  get iconDescColor(): string {
    return this.selected === 'desc' && !this.isDisabled
      ? QRIcon.COLOR_PRIMARY_700
      : QRIcon.COLOR_GREY_400;
  }

  onAsc(): void {
    if (this.isDisabled) {
      return;
    }
    this.orderChange.emit('asc');
  }

  onDesc(): void {
    if (this.isDisabled) {
      return;
    }
    this.orderChange.emit('desc');
  }
}
